import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { Col, Row } from 'reactstrap';
import { Role } from 'types';
import AccordionItem from 'views/Widgets/AccordionItem';
import AdminRoleAddOrEditButton from './AdminRoleAddOrEditButton';
import AdminRolesAssignmentTable from './AdminRolesAssignmentTable';
import { PersonRole } from './types';

interface Props {
  title: string;
  description: string;
  emptyStateTitle: string;
  values: PersonRole[];
  role: Role;
  onItemChange: (values: PersonRole) => void;
  onItemDelete: (values: PersonRole) => void;
}

const AdminRolesSection: FC<Props> = ({
  title,
  description,
  emptyStateTitle,
  values,
  role,
  onItemChange,
  onItemDelete,
}) => {
  const { formatMessage } = useIntl();
  return (
    <AccordionItem
      wrapInCard={false}
      className="pb-4"
      label={
        <div className="py-2">
          <h2 className="mb-2">{title}</h2>
          <span className="text-muted">{description}</span>
        </div>
      }
    >
      <div>
        <div className="mt-3">
          <AdminRolesAssignmentTable
            title={title}
            role={role}
            values={values}
            emptyStateTitle={emptyStateTitle}
            onItemChange={onItemChange}
            onItemDelete={onItemDelete}
          />
        </div>
      </div>
      <Row className="mt-0 pt-0">
        <Col className="text-start col-auto">
          <AdminRoleAddOrEditButton
            role={role}
            roleName={title}
            buttonText={
              <>
                <i
                  className="fe fe-plus"
                  style={{ position: 'relative', top: '2px' }}
                />{' '}
                {formatMessage(
                  {
                    id: 'app.views.administration.people_administration.administrators.admin_roles_section.title.add_administrator',
                    defaultMessage: 'Add {title}',
                  },
                  {
                    title,
                  }
                )}
              </>
            }
            title={formatMessage(
              {
                id: 'app.views.administration.people_administration.administrators.admin_roles_section.title.add_administrator',
                defaultMessage: 'Add {title}',
              },
              {
                title,
              }
            )}
            callback={onItemChange}
          />
        </Col>
      </Row>
    </AccordionItem>
  );
};

export default React.memo(AdminRolesSection);
